import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import { useCallHistoryDataEndpoint } from 'components/admin/businesses/assist/queries/useCallHistoryDataEndpoint';
import { CentsDataGrid } from 'components/common/dataGrid/dataGrid';

const COLUMNS = [
  { headerName: 'Business Name', field: 'businessName', flex: 2 },
  { headerName: 'Business Phone Number', field: 'businessPhone', flex: 1 },
  { headerName: 'Customer Name', field: 'customerName', flex: 1 },
  { headerName: 'Customer Phone', field: 'customerPhone', flex: 1 },
  { headerName: 'Hours and Locations', field: 'hoursAndLocations', flex: 1 },
  { headerName: 'Services and Prices', field: 'servicesAndPrices', flex: 1 },
  { headerName: 'New Order Flow', field: 'newOrder', flex: 1 },
  { headerName: 'Existing Order Flow', field: 'existingOrder', flex: 1 },
  { headerName: 'Attendent Flow', field: 'attendent', flex: 1 },
  {
    headerName: 'Start Date/Time',
    type: 'dateTime',
    field: 'startDateTime',
    flex: 2,
    valueFormatter: (params) => {
      return moment(params.value).format('MM-D-YYYY h:mm A');
    },
  },
  { headerName: 'Call Duration', field: 'callDuration', flex: 1 },
  {
    headerName: 'Call Cost',
    field: 'callCost',
    flex: 1,
    valueFormatter: (params) => {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(params.value / 100);
    },
  },
  { headerName: 'Call Summary', field: 'callSummary', flex: 2 },
  { headerName: 'Transcript', field: 'transcript', flex: 1 },
  { headerName: 'Recording URL', field: 'recording_url', flex: 1 },
  { headerName: 'Call Reason', field: 'call_reason', flex: 1 },
  { headerName: 'Transfer Reason', field: 'transfer_reason', flex: 1 },
  { headerName: 'User Sentiment', field: 'user_sentiment', flex: 1 },
];

const AssistCallsTable = () => {
  const [startDate, setStartDate] = useState(moment().subtract(7, 'day'));
  const [endDate, setEndDate] = useState(moment());

  const { isLoading: isLoadingCallHistory, data: callHistoryData } = useCallHistoryDataEndpoint(
    null,
    moment(startDate).set({ hour: 0, minute: 0, second: 0 }).utc().format(),
    moment(endDate).set({ hour: 23, minute: 59, second: 59 }).utc().format(),
  );

  const handleRowClick = (row) => {
    const url = `https://dashboard.retellai.com/callHistory?history=${row.id}`;
    window.open(url, '_blank');
  };

  return (
    <div className="page-container">
      <div className="assist-header">
        <h1>Cents Assist Calls</h1>
      </div>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <div>
          <DatePicker
            className="start-date-picker"
            label="Start Date"
            value={startDate}
            onChange={setStartDate}
            renderInput={(params) => <TextField {...params} />}
          />
          <DatePicker
            className="end-date-picker"
            label="End Date"
            value={endDate}
            onChange={setEndDate}
            renderInput={(params) => <TextField {...params} />}
          />
        </div>
      </LocalizationProvider>
      <CentsDataGrid
        tableName="globalCentsAssistCalls"
        data={callHistoryData}
        onRowClick={handleRowClick}
        columns={COLUMNS}
        isLoading={isLoadingCallHistory}
      />
    </div>
  );
};

export default AssistCallsTable;
